__webpack_require__.p = "/insights-static/";